// src/core/hooks/use-is-home.ts
'use client';

import { usePathname } from 'next/navigation';

export function useIsHome() {
  const pathname = usePathname() || '/';
  const segments = pathname.split('/').filter(Boolean);
  return segments.length === 0 || segments.length === 1;
}